import { useEffect } from "react";
import { getTaboolaPageDetails } from "@features/taboola/utils/helpers";

const useTaboola = ({
  pageType,
  url,
  container,
  placement,
  isFlush = false,
}: TaboolaProps) => {
  useEffect(() => {
    if (typeof window === "undefined") return;

    window._taboola = window._taboola || [];

    const pageDetails = getTaboolaPageDetails(pageType, url);
    if (pageDetails === null) return;

    window._taboola.push(pageDetails);
    window._taboola.push({
      mode: "thumbnails-base-widget",
      target_type: "mix",
      container,
      placement,
    });

    if (isFlush) window._taboola.push({ flush: true });
  }, [pageType, url, container, placement, isFlush]);
};

export default useTaboola;
